<template>
  <wo-link v-if="value" :href="href" target="_blank">{{ linkLabel }}</wo-link>
</template>
<script>

export default {
  name: 'PoEmailLink',
  props: {
    labelKey: String,
    label: String,
    value: String
  },
  computed: {
    linkLabel () {
      return this.labelKey ? this.$t(this.labelKey) : this.label || this.value
    },
    href () {
      return `mailto:${this.value}`
    }
  }
}
</script>
